import * as React from "react";
import { Paper, LinearProgress } from '@material-ui/core';

import './Filter.scss';
import gql from "graphql-tag";
import { Query } from 'react-apollo';

// tslint:disable-next-line:no-empty-interface
export interface IFilterProps {
  filters?: JSX.Element[];
}

// tslint:disable-next-line:no-empty-interface
export interface IFilterState {

}

const VERIFY_RENDER = gql`
query publisherPublisherFilterCount($customFilter:  PublisherCustomFilter) {
  publisherPublisherFilterCount(publisherCustomFilter: $customFilter) {
    count
  }
  publisherPublisherFilterCount @client
}
`;

export class Filter extends React.Component<IFilterProps, IFilterState> {
  public render() {
    const jsonFilter = {
      "customFilter": {
        "isChart": false,
      }
    };
    return (
      <Query query={VERIFY_RENDER} fetchPolicy="network-only"
        variables={jsonFilter}>
        {({ loading, error, data, client: cliente }) => {
          if(data != null && data !== undefined) {
            return <div className="wrapper">
              {loading ? <LinearProgress /> :
                <Paper>
                  <div className="filter-bar">
                    <ul>
                      {this.props.filters && this.props.filters.map((item) => {
                        if (window.location.href.indexOf('bookstore') === -1 && item.key === '2' &&
                            data.publisherPublisherFilterCount.count === 1) {
                          return ('')
                        } else {
                          return (
                            <li key={item.key ? item.key : undefined} >{item}</li>
                          )
                        }
                      }
                      )}
                    </ul>
                  </div>
                </Paper>}
            </div>;
          } else {
            return null;
          }
        }}
      </Query>)
  }
}



// WEBPACK FOOTER //
// ./src/component/shared/layout/filter/Filter.tsx